export const FLAG_GETTING_DOCUMENT_TYPES = 'FLAG_GETTING_DOCUMENT_TYPES';
export const GET_DOCUMENT_TYPES = 'GET_DOCUMENT_TYPES';
export const CLEAR_DOCUMENT_TYPES = 'CLEAR_DOCUMENT_TYPES';
